import {Component, OnInit} from '@angular/core';
import {UtDialogService} from 'src/app/ui';
import {UserService} from '../services/user/user.service';
import {UserDto} from '@api/utisha-backend';
import {ProfileDialogComponent} from '../profile/profile-dialog/profile-dialog.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [RouterOutlet],
})
export class HomeComponent implements OnInit {
  constructor(
    private dialog: UtDialogService,
    private userService: UserService,
  ) {}

  async ngOnInit(): Promise<void> {
    // this.checkUserProfileComplete();
  }

  async checkUserProfileComplete(): Promise<void> {
    const user: UserDto = await this.userService.getUser();
    if (!user.profileComplete) {
      const ref = this.dialog.open(ProfileDialogComponent);
      ref.afterClosed().subscribe(() => {
        this.userService.refresh();
        this.checkUserProfileComplete();
      });
    }
  }
}
